import { getImageUrl, getImageUrls } from './imageUtils';

export const formatVehicleForCard = (vehicle) => {
  if (!vehicle || !vehicle._id) {
    return null;
  }

  const transmission = vehicle.specs?.transmission === 'AUTOMATIC' ? 'Automatique' : 'Manuel';
  const city = vehicle.vehicleLocation?.cityName || vehicle.location?.city || 'N/A';
  const ownerName = vehicle.owner?.fullName || vehicle.owner?.email || 'N/A';
  const ownerType = vehicle.owner?.vendorDetails?.companyName ? 'Ville' : 'Direct';

  const brandName = vehicle.specs?.brand?.name || vehicle.specs?.brand || '';
  const modelName = vehicle.specs?.model?.name || vehicle.specs?.model || '';
  const year = vehicle.specs?.year;

  let title = vehicle.title;
  if (!title || title.trim() === '') {
    if (brandName && modelName) {
      title = year ? `${brandName} ${modelName} ${year}` : `${brandName} ${modelName}`;
    } else {
      title = 'Vehicule';
    }
  }

  const rating = vehicle.rating?.average !== undefined && vehicle.rating?.average !== null
    ? Number(vehicle.rating.average)
    : 4.5;

  return {
    id: vehicle._id,
    _id: vehicle._id,
    title,
    make: brandName || 'Unknown',
    model: modelName || 'Unknown',
    year: year || new Date().getFullYear(),
    transmission,
    seats: vehicle.specs?.seats || 5,
    price: vehicle.pricing?.basePrice || 0,
    currency: vehicle.pricing?.currency || 'MAD',
    rating,
    image: getImageUrl(vehicle.images?.[0]),
    images: getImageUrls(vehicle.images || []),
    location: `${city}, Maroc`,
    agency: {
      name: ownerType === 'Ville' ? vehicle.owner?.vendorDetails?.companyName || ownerName : ownerName,
      type: ownerType,
    },
    rules: vehicle.rules || [],
    cancellationPolicies: vehicle.cancellationPolicies || [],
    features: vehicle.features || [],
    description: vehicle.description || '',
    type: vehicle.type || 'CAR',
    fuel: vehicle.specs?.fuel?.name || vehicle.specs?.fuel || 'Unknown',
  };
};

